import LoadingState from '@/api/LoadingState';

const state = {
  loadingState: LoadingState.INITIAL,
  users: []
}
export default state
